module.exports = __webpack_public_path__ + "img/dateOfBirth.771b335e.svg";